const applications = {
  permissionSource: 'api::application.application',
  creationTitle: 'Create Application',
  creationEndPoint: '/applications',
  detailTitle: 'Application',
  detailEndPoint: '/applications/:id?populate=*',
  detail: [
    {
      label: 'Applicant Name in English',
      value: 'applicant_name_in_english',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Applicant Name in Chinese',
      value: 'applicant_name_in_chinese',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Position Applied',
      value: 'position_applied',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Salary Expected',
      value: 'salary_expected',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Earliest Date Available',
      value: 'earliest_date_available',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Birthday',
      value: 'birthday',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Correspondence Address',
      value: 'correspondence_address',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Contact Phone Number',
      value: 'contact_phone_number',
      tag: 'input',
      type: 'text',
      required: true,
    },
    {
      label: 'Education Academic Qualification Attained',
      value: 'education_academic_qualification_attained',
      tag: 'input',
      type: 'text',
    },
    {
      label: 'Training Professional Qualification Attained',
      value: 'training_professional_qualification_attained',
      tag: 'input',
      type: 'text',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
  static_detail: [
    {
      label: 'Applicant Name in English',
      value: 'applicant_name_in_english',
      tag: 'static-text',
    },
    {
      label: 'Applicant Name in Chinese',
      value: 'applicant_name_in_chinese',
      tag: 'static-text',
    },
    {
      label: 'Position Applied',
      value: 'position_applied',
      tag: 'static-text',
    },
    {
      label: 'Salary Expected',
      value: 'salary_expected',
      tag: 'static-text',
    },
    {
      label: 'Earliest Date Available',
      value: 'earliest_date_available',
      tag: 'static-text',
    },
    {
      label: 'Birthday',
      value: 'birthday',
      tag: 'static-text',
    },
    {
      label: 'Correspondence Address',
      value: 'correspondence_address',
      tag: 'static-text',
    },
    {
      label: 'Contact Phone Number',
      value: 'contact_phone_number',
      tag: 'static-text',
    },
    {
      label: 'Education Academic Qualification Attained',
      value: 'education_academic_qualification_attained',
      tag: 'static-text',
    },
    {
      label: 'Training Professional Qualification Attained',
      value: 'training_professional_qualification_attained',
      tag: 'static-text',
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default applications
